import React from 'react';

// @ts-ignore FIXME: Try `npm install @types/rc-form` if it exists or a... Remove this comment to see the full error message
import { createForm, formShape } from 'rc-form';

// HOC to use createForm from rc-form without consuming the prop types of the component
export default <Props extends {}>(
  Component: React.ComponentType<Props>
): React.ComponentType<Omit<Props, 'form'>> => createForm()(Component);
